import { reducer as users } from "./users/slice";

export const reducer = {
  users,
};
